var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-black flex flex-col py-2 sm:px-6 lg:px-8 h-screen player-page"},[_c('VideoPlayer',{attrs:{"pause":_vm.video_pause},on:{"checkout":_vm.onStartCheckout}}),_c('CheckoutBlock',{attrs:{"start":_vm.startCheckout},on:{"checkout-done":_vm.checkoutDone,"checkout-cancelled":_vm.checkoutCancelled}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }